import { useCallback } from 'react';

import { JSONType } from '@/utils';

import { toAgentRunId, toFileId, useBatchGetAgentRun } from './api';
import { useClient } from './useClient';

export type UseCreateExportOpts = {
  agentId?: string | null;
  runIds?: string[] | null;
};

export const useCreateExport = ({ agentId, runIds }: UseCreateExportOpts) => {
  const { data: runs } = useBatchGetAgentRun(runIds?.map((runId) => toAgentRunId(agentId, runId)));
  const { client } = useClient();

  const createExport = useCallback(async () => {
    const fileIds = runs.map((run) => toFileId(run.variablesFileUrl));
    const variables: JSONType[] = [];

    for (const fileId of fileIds) {
      if (fileId) {
        const file = await client.makeFileServerGetRequest(fileId.fileUrl);
        variables.push(JSON.parse(await file.text()));
      } else {
        variables.push({});
      }
    }

    return runs.map((run, index) => ({
      run,
      result: { runId: run.runId, variables: variables[index] },
    }));
  }, [client, runs]);

  return { createExport };
};
